"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _lodash = require("lodash");

var _default = function _default(numOrString) {
  var n = (0, _lodash.toNumber)(numOrString);
  return isNaN(n) ? numOrString : n.toLocaleString();
};

exports["default"] = _default;